const WISHLIST_STORAGE_KEY = 'teravie:wishlist';
const WISHLIST_HANDLES_STORAGE_KEY = 'teravie:wishlist:handles';

function getWishlist() {
  try {
    const stored = JSON.parse(localStorage.getItem(WISHLIST_STORAGE_KEY));
    return Array.isArray(stored) ? stored : [];
  } catch (error) {
    return [];
  }
}

function getWishlistHandles() {
  try {
    const stored = JSON.parse(localStorage.getItem(WISHLIST_HANDLES_STORAGE_KEY));
    return stored && typeof stored === 'object' ? stored : {};
  } catch (error) {
    return {};
  }
}

function setWishlist(ids) {
  localStorage.setItem(WISHLIST_STORAGE_KEY, JSON.stringify(ids));
  renderWishlistState(ids);
  publish(PUB_SUB_EVENTS.wishlistUpdate, { ids });
}

function toggleWishlistProduct(productId, productHandle) {
  const ids = getWishlist();
  const handles = getWishlistHandles();
  const index = ids.indexOf(productId);

  if (index === -1) {
    ids.push(productId);
    if (productHandle) handles[productId] = productHandle;
  } else {
    ids.splice(index, 1);
    delete handles[productId];
  }

  localStorage.setItem(WISHLIST_HANDLES_STORAGE_KEY, JSON.stringify(handles));
  setWishlist(ids);
}

function renderWishlistState(ids) {
  document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
    const isActive = ids.includes(button.dataset.productId);
    button.classList.toggle('wishlist-toggle--active', isActive);
    button.setAttribute('aria-pressed', isActive);
  });

  const bubble = document.querySelector('[data-wishlist-count-bubble]');
  if (bubble) {
    const countEl = bubble.querySelector('[data-wishlist-count]');
    const previousCount = countEl ? countEl.textContent : null;

    bubble.hidden = ids.length === 0;
    if (countEl) countEl.textContent = ids.length;

    if (countEl && previousCount !== null && previousCount !== String(ids.length)) {
      bubble.classList.remove('wishlist-count-bubble--bump');
      void bubble.offsetWidth;
      bubble.classList.add('wishlist-count-bubble--bump');
    }
  }
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-wishlist-toggle]');
  if (!button) return;
  event.preventDefault();
  toggleWishlistProduct(button.dataset.productId, button.dataset.productHandle);
  button.classList.remove('wishlist-toggle--pulse');
  void button.offsetWidth;
  button.classList.add('wishlist-toggle--pulse');
});

document.addEventListener('DOMContentLoaded', () => {
  renderWishlistState(getWishlist());
});
